export const setIsLogo = (payload) => {
  return {
    type: "LOGO",
    payload: payload,
  };
};

export const setFirstPageUrl = (payload) => {
  return {
    type: "FIRST_PAGE_URL",
    payload: payload,
  };
};